// extracted by mini-css-extract-plugin
export var card = "partners-module--card--77d84";
export var logos = "partners-module--logos--407e1 partners-module--section--cf790";
export var logosList = "partners-module--logosList--7d959";
export var section = "partners-module--section--cf790";